<template>
  <div class="layout my-contacts">
    <div class="tab_content">
      <div class="list_wrap">
        <List v-model="loading" :finished="finished" @load="loadMore"> 
          <div class="item" v-for="(item,index) in list" :key="index">
            <div class="item_info">
              <div class="line">
                <span>Company：</span><p class="van-ellipsis">{{item.exhibitor.company.nameEn}}</p>
              </div>
              <div class="line">
                <span>Product：</span><p class="van-ellipsis">{{item.productName}}</p>
              </div>
              <div class="line">
                <span>Quantity：</span><p class="van-ellipsis">{{item.amount}}</p>
              </div>
              <div class="line">
                <span class="bz">Message：</span><p>{{item.remark}}</p>
              </div>
            </div>
            <div class="item_bottom">
              <div class="state_ok" v-if="item.auditState==1">
                <span v-if="item.state==1" class="ok">Have read</span>
                <span v-else >Unread</span>
                <p>{{item.createAt}}</p>
              </div>
              <div class="item_state" v-else>
                <div class="state0" :class="item.auditState==-1?'state-1':''">{{item.auditState==-1?'Audit failure':'Under review'}}</div>
                <div class="state_no" v-if="item.auditState==-1">
                  <span @click="delInquiry(item.id)">delete</span>
                  <div @click="reEdit(item)">Re edit</div>
                </div>
              </div>
            </div>
          </div>
          <div slot="loading" class="f-tac loading">
            <img src="@assets/img/new/icon-loading.png" />
            loading...
          </div>
          <div slot="finished" class="f-tac loading">It's the end~</div>
        </List>
      </div>
    </div>
    <inquiryNew ref="inquiryNew" @finish="getList(true)" :isEdit="true"></inquiryNew>
  </div>
</template>
<script>
import moment from "moment";
import inquiryNew from "@components/inquiry-new"; //索取样品
import { mapActions, mapGetters, mapMutations } from "vuex";
import { List } from "vant";
export default {
  name: "my-contacts",
  components:{
    List,
    inquiryNew
  },
  data() {
    return {
      loading: false,   //消息列表加载状态
      finished: false,  //消息列表是否完成状态
      list: [],    //消息列表
      pageIndex: 0,
      pageSize:20,
    } 
  },
  async created(){
    if(this.$route.params.id){
      this.$store.commit('setExhibitionId',this.$route.params.id);
    }
    if(!this.userInfo){
      await this.$Myapollo.getUserInfo(this);
    }
    if(!this.exhibitionInfo&&this.exhibitionId){
      await this.$Myapollo.getExhibitionInfo(this,this.exhibitionId,this.userInfo.userId);
    }
    this.$Myapollo.addExhibitionView();
  },
  mounted(){
  },
  computed: {
    ...mapGetters({
      userInfo:'getUserInfo',
      exhibitionId:"getExhibitionId",
      exhibitionInfo:"getExhibitionInfo"
    }),

  },
  methods:{
    ...mapActions({
      graphqlPost:'en/graphqlPostByZXS',
      delEnquiryNew:'my/delEnquiryNew'
    }),
    async getList(isFinish=false){
      let query=`
        query($query:QueryInput!){
          exhibitorNewEnquiryQuery{
            query(query:$query){
                hasNextPage
                pageIndex
                totalCount
                items {
                  amount
                  auditRemark
                  auditState
                  auditTime
                  auditUser
                  createAt
                  exhibitionId
                  exhibitor{
                    id
                    company{
                      name
                      nameEn
                    }
                  }
                  id
                  productId
                  productName
                  remark
                  state
                  stateAt
                  userId
                }
              }
            }
        }
      `;
      let where = {
        Equal: {
          n: "userId",
          v: this.userInfo.userId,
        },
        EqualA: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
      };
      let order = [
        {
          N: "createAt",
          v: 0,
        },
      ];
      let opt={
        query:query,
        variables: {
          query: {
            page: this.pageIndex,
            size: this.pageSize,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          },
        },
      }
      let data = await this.graphqlPost(opt);
      let res = JSON.parse(JSON.stringify(data.data.exhibitorNewEnquiryQuery.query));
      res.items.forEach(e => {
        e.createAt=moment(e.createAt).format('YYYY/MM/DD HH:mm:ss');
        if(e.imgUrls){
          e.imgUrls= e.imgUrls.split(';');
        }
      });
      if(this.pageIndex==1||isFinish){
        this.list=res.items
      }else{
        this.list=[...new Set([...this.list,...res.items])];
      }
      this.loading=false;
      if (!res.hasNextPage) {
        this.finished = true;
      }
      console.log(this.list,'resss询盘');
    },
    loadMore(){
      if(this.finished) return;
      this.pageIndex+=1;
      this.getList();
    },
    async delInquiry(id){
      let res=await this.delEnquiryNew(id);
      if(res.result){
        this.getList();
        this.$toast.success('Deletion succeeded')
      }else{
        this.$toast.fail(res.message||'Deletion failed');
      }
    },
    reEdit(e){
      let opt={
        remark:e.remark,
        id:e.id,
        amount:e.amount
      }
      this.$refs.inquiryNew.open(opt);
    },
    
  }
};
</script>

<style lang="scss" scoped>
.my-contacts{
  background: #f2f2f2;
  .tab_content{
    padding: 0.3rem 0.3rem 0;
    .list_wrap{
      .item{
        padding: 0.2rem;
        background: #fff;
        margin-bottom: 0.3rem;
        border-radius: 0.1rem;
        box-shadow: 0px 0px 0.1rem 0px rgba(0, 0, 0, 0.1);
        .item_info{
          .line{
            display: flex;
            align-items: center;
            margin-bottom: 0.15rem;
            span{
              flex-shrink: 0;
              font-size: 0.26rem;
              width: 1.37rem;
              color: #666;
              &.bz{
                margin-bottom:auto;
              }
            }
            p{
              font-size: 0.26rem;
              color: #333;
            }
          }
        }
        .item_bottom{
          *{
            font-size: 0.22rem;
          }
          margin-top: 0.2rem;
          .state_ok{
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #666;
            span{
              &.ok{
                color:#1890ff ;
              }
            }
          }
          .item_state{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .state0{
              color: #ff9752;
              &.state-1{
                color:#ff563a;
              }
            }
            .state_no{
              display: flex;
              align-items: center;
              span{
                color:#ff563a;
                margin-right: 0.3rem;
              }
              div{
                padding: 0.05rem 0.2rem;
                border-radius: 0.05rem;
                background: #ff954f;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
